import { render, staticRenderFns } from "./EventGenre.vue?vue&type=template&id=0278096c"
import script from "./EventGenre.vue?vue&type=script&lang=js"
export * from "./EventGenre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports